import {
 ActionButton,
 checkImage,
 DeleteSingleButton,
 StockCheckbox,
 ToggleSwitch,
} from "../../../../helper/ImageFormat";
import CustomPagination from "../../../../helper/Pagination";
import Spinner from "../../../../Components/spinner";
import { formatDate } from "../../../../utils/constants";

const SearchProductTable = ({
 loading,
 productData,
 currentPage,
 perPage,
 handleStatusToggle,
 totalCount,
 totalPages,
 handlePageClick,
 handleFancyBox,
 columnsList,
 handleDelete,
 setSelected,
 selected,
 handleStockToggle,
}) => {
 const renderCell = (col, data) => {
  switch (col.key) {
   case "image":
    return (
     <span
      style={{ cursor: "pointer" }}
      onClick={() => handleFancyBox(data.image)}
     >
      {checkImage(data?.image?.[0])}
     </span>
    );
   case "name":
    const displayTitle =
     data.name.length > 20 ? data.name.slice(0, 20) + "..." : data.name;
    return <span title={data.name}>{displayTitle}</span>;
   case "sku":
    return data?.sku;
   case "quantity":
    return data?.quantity;
   case "price":
    return `${data?.retail_price?.toFixed(2)}`;
   case "discount":
    return data?.retail_discount ? `${data?.retail_discount} %` : "-";
   case "isCatalogue":
    return data?.catalogue_id ? (
     <i className="fa-solid fa-check text-success"></i>
    ) : (
     <i className="fa-solid fa-xmark text-danger"></i>
    );
   case "status":
    return (
     <ToggleSwitch
      data={data}
      name="isActive"
      checked={data.isActive}
      handleStatusToggle={handleStatusToggle}
      module={"Products"}
     />
    );
   case "outofStock":
    return (
     <StockCheckbox
                     data={data}
                     checked={data.outofStock}
                     handleStockToggle={handleStockToggle}
                    />
    );
   case "action":
    return <DeleteSingleButton handleDelete={handleDelete} item={data} />;
   case "createdAt":
    return formatDate(data.createdAt);
   case "updatedAt":
    return formatDate(data.updatedAt);
   default:
    return data[col.key] || "-";
  }
 };


 return (
  <div className="row">
   <div className="col-md-12 grid-margin stretch-card">
    <div className="card">
     <div className="card-body">
      <div className="pb-20 table-responsive">
       <table className="custom-table table table-striped">
        <thead>
         <tr>
         
          {columnsList
           .filter((col) => col.visible)
           .map((col) => (
            <th key={col.key}>{col.label}</th>
           ))}
         </tr>
        </thead>

        <tbody>
         {loading ? (
          <tr>
           <td colSpan={columnsList.length + 2} className="text-center">
            <Spinner />
           </td>
          </tr>
         ) : productData?.length > 0 ? (
          productData.map((data, index) => (
           <tr key={data.id}>
            
            {columnsList
             .filter((col) => col.visible)
             .map((col) => (
              <td key={col.key}>{renderCell(col, data)}</td>
             ))}
           </tr>
          ))
         ) : (
          <tr>
           <td colSpan={columnsList.length + 2} className="text-center">
            <h4>No data available</h4>
           </td>
          </tr>
         )}
        </tbody>
       </table>
      </div>

      {productData?.length > 0 && (
       <CustomPagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageClick}
        perPage={perPage}
        totalCount={totalCount}
       />
      )}
     </div>
    </div>
   </div>
  </div>
 );
};

export default SearchProductTable;
